var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-height-flag box" },
    [
      _c("oaFromBox", {
        attrs: {
          search: _vm.search,
          total: _vm.total,
          isBack: true,
          title: "回收站",
          btnText: "彻底删除",
          btnIcon: false,
          isViewSearch: false,
          sortSearch: false,
          dropdownList: _vm.dropdownList,
        },
        on: {
          backFn: _vm.backFn,
          addDataFn: _vm.batchDeletFn,
          dropdownFn: _vm.dropdownFn,
          confirmData: _vm.confirmData,
        },
      }),
      _vm._v(" "),
      _vm.fileData.length > 0
        ? _c(
            "div",
            { staticClass: "content mt10 v-height-flag" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.fileData, height: _vm.tableHeight },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", { attrs: { type: "selection" } }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "名称", "min-width": "250" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.name) +
                                  "\n          "
                              ),
                              scope.row.type == 1
                                ? _c("span", [
                                    _c("i", {
                                      staticClass: "icon iconfont",
                                      class: _vm.getFileType(
                                        scope.row.type,
                                        scope.row.file_url
                                      ),
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v("." + _vm._s(scope.row.file_ext)),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      691862269
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "path", label: "位置", "min-width": "150" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "deleted_at", label: "删除时间" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "操作人" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.del_user
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: scope.row.del_user.avatar,
                                        alt: "",
                                      },
                                    }),
                                    _vm._v(
                                      _vm._s(scope.row.del_user.name) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2147702866
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-dropdown",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-dropdown-link el-button--text el-button more",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "iconfont icongengduo1",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm.userInfo.id == scope.row.master_uid
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.deleteFn(
                                                    scope.row.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                彻底删除\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.userInfo.id == scope.row.master_uid ||
                                      _vm.userInfo.id == scope.row.del_user.id
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.recoveryFn(
                                                    scope.row.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                恢复文件\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2182481411
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.where.page,
                      "page-size": _vm.where.limit,
                      "page-sizes": [15, 20, 30],
                      total: _vm.total,
                      layout: "total,sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("default-page", { attrs: { index: 7, "min-height": 510 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }